// extracted by mini-css-extract-plugin
export var close = "C_cl";
export var content = "C_cp";
export var popIn = "C_ck";
export var reader = "C_cj";
export var reader__embedded = "C_cm";
export var reader__open = "C_cn";
export var scrollbar = "C_bT";